import { useAuth } from '../pages/login/OAuth';

const useBuildingService = () => {
    const { api } = useAuth();

    const getBuilding = (id) =>
        api().get(`/buildings/${id}`);

    const getBuildings = (params) =>
        api().get('/buildings/', { params });

    const createBuilding = (data) =>
        api().post('/buildings/new', data);

    const updateBuilding = (data) =>
        api().patch('/buildings/update', data);

    const disableBuilding = (id) =>
        api().patch('/buildings/disable', { building_id: id });

    const addBuildingItem = (data) =>
        api().post('/buildings/add_item', data);

    const disableBuildingItem = (id) =>
        api().patch('/buildings/disable_item', { item_id: id });

    return {
        getBuilding,
        getBuildings,
        createBuilding,
        updateBuilding,
        disableBuilding,
        addBuildingItem,
        disableBuildingItem,
    };
};

export default useBuildingService;
